<template>
  <base-section id="pro-features">
    <base-section-heading :title="$i18n.t(heading)">
      <section id="content" class="gray-area text-center">
        <div class="container">
          <div class="text-center">
            <v-btn color="success" to="/dashboard">
              {{ $i18n.t("Go To Dashboard") }}</v-btn
            >
          </div>
        </div>
      </section>
    </base-section-heading>
  </base-section>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  heading = "Payment Successful";
}
</script>